var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2137 13.3283L11.8356 9.23311H7.94521V6.5768C7.94521 5.45617 8.48767 4.3632 10.2301 4.3632H12V0.876797C12 0.876797 10.3945 0.600098 8.86027 0.600098C5.6548 0.600098 3.56164 2.56189 3.56164 6.11194V9.23311H0V13.3283H3.56164V23.2285C4.27671 23.342 5.00822 23.4001 5.75342 23.4001C6.49863 23.4001 7.23014 23.342 7.94521 23.2285V13.3283H11.2137Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.cea98a383f2b00dd6b9d65d5a3978e5f.svg";
export { ForwardRef as ReactComponent };